var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgObserver(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5C5B69",
    fillRule: "evenodd",
    d: "M7.999 6.427a1.609 1.609 0 1 0 1.608 1.608 1.61 1.61 0 0 0-1.608-1.608Zm0 4.215a2.61 2.61 0 0 1-2.607-2.607 2.61 2.61 0 0 1 2.607-2.608 2.611 2.611 0 0 1 2.608 2.608 2.61 2.61 0 0 1-2.608 2.607Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 14,
    height: 12,
    x: 1,
    y: 2,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M1.333 2.667h13.333v10.736H1.333V2.667Z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5C5B69",
    fillRule: "evenodd",
    d: "M2.38 8.035c1.24 2.74 3.328 4.368 5.62 4.369 2.29-.001 4.38-1.63 5.62-4.369C12.38 5.296 10.29 3.668 8 3.667c-2.291 0-4.38 1.63-5.62 4.368ZM8 13.404h-.002c-2.758-.002-5.234-1.935-6.624-5.172a.501.501 0 0 1 0-.394c1.39-3.236 3.867-5.169 6.624-5.171h.004c2.757.002 5.233 1.935 6.623 5.17a.495.495 0 0 1 0 .395c-1.39 3.237-3.866 5.17-6.623 5.172H8Z",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObserver);
export default __webpack_public_path__ + "static/media/observer.0e54472a8941423f8111897c59b893b4.svg";
export { ForwardRef as ReactComponent };